<template>
  <div class="error" v-if="errors && errors.length > 0">
    <p>{{ $store.getters.getStringTranslation('somethingWrong') }}:</p>
    <ul>
      <li v-for="item in errors" :key="item.id">
        <template v-if="item.opts && item.opts.type">{{ capitalize(item.opts.type) }}: </template>
        {{ getError(item.l10n) }}
      </li>
    </ul>
  </div>
</template>

<script>
import Capitalize from '@/components/mixins/Capitalize.js'

export default {
  props: ['errors'],
  name: 'ErrorPrompt',
  mixins: [Capitalize],
  methods: {
    getError(item) {
      const error = item.find((x) => x.lang === this.$store.state.ui.lang)
      return error.message
    },
  },
}
</script>
